export default {
    mixed: {
        required: 'Бул бош болбошу керек',
        oneOf: 'Сырсөз жана ырастоо дал келиши керек',
    },
    string: {
        required: 'Бул бош болбошу керек',
        max: 'Бул маани ${max} белгиден ашпашы керек'
    },
    number: {
        required: 'Бул бош болбошу керек',
        positive: 'Бул маани оң болушу керек',
        integer: 'Бул маани сандардан турат'
    },
    date: {
        required: 'Бул бош болбошу керек',
        min: '${min} кийин болуш керек',
        max: '${max} чейин болуш керек',
    },
    array: {
        min: 'Кеминде ${min} элемент болушу керек',
    }
}